import React from 'react';
import '../App.css';

export const Footer = (props) => {
    return (
        <>
        <footer className ="footerlow">
            <p>Copyright @2022</p>
            <p>Abhishek Dubey</p>
        </footer>
        </>
    )
}
